/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_CompanyInputs */

const ja_nav_company = /** @type {(inputs: Nav_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会社概要`)
};

const en_nav_company = /** @type {(inputs: Nav_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`COMPANY`)
};

/**
* | output |
* | --- |
* | "COMPANY" |
*
* @param {Nav_CompanyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_company = /** @type {((inputs?: Nav_CompanyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_CompanyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_nav_company(inputs)
	return en_nav_company(inputs)
});